module.exports = __webpack_public_path__ + "img/zh_CN-box4-text-light.14c1f359.png";